import type { AuthCallback } from "@/lib/supabase";

export type VerifyScreen = "checking" | "password" | "onboarding" | "expired" | "waiting";

export const VERIFY_EXPIRED_TITLE = "확인 링크가 만료됐거나 잘못됐습니다";
export const VERIFY_EXPIRED_BODY = "링크는 한 번만, 24시간 안에만 쓸 수 있습니다. 가입한 이메일을 넣으면 확인 메일을 다시 보냅니다.";
export const VERIFY_WAITING_TITLE = "메일의 확인 링크를 눌러 주세요";
export const VERIFY_WAITING_BODY = "링크를 누르면 이 화면으로 돌아와 비밀번호를 정하고 회사 정보 입력으로 이어집니다. 메일이 없으면 다시 보낼 수 있습니다.";
export const VERIFY_PASSWORD_TITLE = "비밀번호 정하기";
export const VERIFY_PASSWORD_BODY = "메일이 확인됐습니다. 앞으로 로그인할 비밀번호를 정해 주세요.";
export const SET_PASSWORD_FAILED_MESSAGE = "비밀번호를 정하지 못했습니다. 잠시 후 다시 시도하세요.";

// 확인 링크로 들어와 세션이 섰으면 비밀번호 정하기(이미 정했으면 회사 정보)로 · 오류면 다시 보내기 · 그 밖은 세션이 있을 때만.
export const verifyScreenOf = (callback: AuthCallback, hasSession: boolean, needsPassword: boolean): Exclude<VerifyScreen, "checking"> => {
  if (callback.kind === "error") return "expired";
  if (hasSession && callback.kind !== "recovery") return needsPassword ? "password" : "onboarding";
  return callback.kind === "signup" ? "expired" : "waiting";
};
